import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ButtonLink } from '@blueprint/ui';

export const Container = styled('div')(
    ({ theme: { spacing, mq } }) => css`
        text-align: center;
        margin: 0 ${spacing['16px']} ${spacing['16px']} ${spacing['16px']};

        ${mq.medium} {
            margin: 0 ${spacing['24px']} ${spacing['24px']} ${spacing['24px']};
        }
    `
);

export const Note = styled('p')(
    ({ theme: { fontSizes, spacing, type, colors } }) => css`
        line-height: ${type.size8LineHeight};
        color: ${colors['text-body']};
        font-size: ${fontSizes[8]};
        margin: ${spacing['32px']} 0 ${spacing['24px']} 0;
    `
);

export const ButtonContainer = styled('div')(
    ({ theme: { mq, spacing } }) => css`
        a {
            width: 100%;
            margin: 0 0 ${spacing['8px']} 0;

            svg {
                margin-right: ${spacing['8px']};
            }
        }

        ${mq.medium} {
            display: flex;

            a {
                flex-grow: 1;
                flex-basis: 33%;

                margin: 0 ${spacing['4px']} ${spacing['4px']} ${spacing['4px']};

                &:first-of-type {
                    margin-left: 0;
                }
                &:last-of-type {
                    margin-right: 0;
                }
            }
        }
    `
);

export const ButtonLinkMobileOnly = styled(ButtonLink)(
    ({ theme: { mq } }) => `
        ${mq.medium} {
            display: none;
        }
    `
);
